import React, { useEffect } from "react";
import Page from "../../components/Page";
import Sidebar from "../../components/Sidebar";
import SidebarDrawer from "../../components/SidebarDrawer";
import AllMessageDrawer from "./Components/AllMessageDrawer";
import People from "./Components/People";
import ChatView from "./Components/ChatView";
import { chosenUserAtom, conversationAtom, usersAtom, conversationsCacheAtom } from "./atoms/ChatAtom";
import { useAtom, useAtomValue } from "jotai";
import axios from "axios";
import {url} from "../../url";
 
const Conversations = () =>{
  const [chosenUser, setChosenUser] = useAtom(chosenUserAtom);
  const [conversation,setConversation] = useAtom(conversationAtom);
  const [conversationsCache, setConversationsCache] = useAtom(conversationsCacheAtom);
  const users = useAtomValue(usersAtom)
  
  // Set initial user only if no user is currently chosen and users are available
  useEffect(()=>{
    if (!chosenUser && users.length > 0) {
      setChosenUser(users[0])
    }
  },[users.length, chosenUser])

  useEffect(()=>{
    const fetchConversation = async()=>{
      if(chosenUser?._id){
        // Check if conversation is already cached
        if (conversationsCache[chosenUser._id]) {
          setConversation(conversationsCache[chosenUser._id]);
          return;
        }

        try {
          const response = await axios.get(url + `/chat/conversation?friendId=${chosenUser._id}`,{headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ localStorage.getItem("token")
          }});
          const tempConversation = response.data.conversation;
          
          // Cache the conversation
          setConversationsCache(prev => ({
            ...prev,
            [chosenUser._id]: tempConversation
          }));
          
          setConversation(tempConversation);
        } catch (error) {
          console.error('Error fetching conversation:', error);
        }
      }
    };
    fetchConversation();
  },[chosenUser?._id]);


  return (
    <Page>
      <div className="conversations">
        <header className="conversations__header">
          <div className="conversations__header__sidebar">
            <SidebarDrawer />
          </div>
          <div className="conversations__header__people">
            <AllMessageDrawer />
          </div>
        </header>
        <div className="conversations__container">
          <div className="conversations__container__sidebar">
            <Sidebar />
          </div>
          {chosenUser?._id && conversation?._id ? (
            <ChatView key={chosenUser._id} />
          ) : (
            <div className="conversations__container__chat">
              <div className="conversations__container__chat__box" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}>
                <p style={{color: '#666'}}>Select a conversation to start chatting</p>
              </div>
            </div>
          )}
          <div className="peopleBox">
            <People />
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Conversations;
